import React from 'react';
import logoImage from '../../images/logo.png';
import '../../css/Header.css';

const Logo: React.FC = () => {
  return (
    <div className="logo-container">
      <img src={logoImage} alt="Logotipo" />
    </div>
  );
};

export default Logo;
